import React from "react";

const CheckboxEditorToolbar = ({
  selectedField,
  updateField,
  setSelectedCheckbox,
}) => {
  if (!selectedField || selectedField.type !== "checkbox") return null;

  const options = [
    { label: "Check", value: "check", icon: "check_box" },
    { label: "Circle", value: "circle", icon: "radio_button_checked" },
    { label: "X", value: "x", icon: "disabled_by_default" },
  ];

  return (
    <div className="py-1 px-2 flex items-center gap-2 bg-white/20">
      <span className="text-sm text-color">Checkbox Style:</span>
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => {
            updateField(selectedField.id, { checkboxStyle: opt.value });
            setSelectedCheckbox(opt.value);
          }}
          className={`px-1 rounded text-color hover:text-tier-primary ${
            selectedField.checkboxStyle === opt.value
              ? "bg-tier-secondary text-tier-primary"
              : "hover:bg-dark-alt"
          }`}
        >
          <span className="material-symbols-outlined text-base">
            {opt.icon}
          </span>
        </button>
      ))}
    </div>
  );
};

export default CheckboxEditorToolbar;
